module.exports = __webpack_public_path__ + "img/logo.403712ec.svg";